// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_Types from "../Restaumatic.PromotionsEngine.Cart.Types/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var PizzaSize = /* #__PURE__ */ (function () {
    function PizzaSize() {

    };
    PizzaSize.value = new PizzaSize();
    return PizzaSize;
})();
var DrinkSize = /* #__PURE__ */ (function () {
    function DrinkSize() {

    };
    DrinkSize.value = new DrinkSize();
    return DrinkSize;
})();
var LE = /* #__PURE__ */ (function () {
    function LE() {

    };
    LE.value = new LE();
    return LE;
})();
var GE = /* #__PURE__ */ (function () {
    function GE() {

    };
    GE.value = new GE();
    return GE;
})();
var EQ = /* #__PURE__ */ (function () {
    function EQ() {

    };
    EQ.value = new EQ();
    return EQ;
})();
var ItemIdFilter = /* #__PURE__ */ (function () {
    function ItemIdFilter(value0) {
        this.value0 = value0;
    };
    ItemIdFilter.create = function (value0) {
        return new ItemIdFilter(value0);
    };
    return ItemIdFilter;
})();
var ProductCategoryIdFilter = /* #__PURE__ */ (function () {
    function ProductCategoryIdFilter(value0) {
        this.value0 = value0;
    };
    ProductCategoryIdFilter.create = function (value0) {
        return new ProductCategoryIdFilter(value0);
    };
    return ProductCategoryIdFilter;
})();
var ParameterValueFilter = /* #__PURE__ */ (function () {
    function ParameterValueFilter(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ParameterValueFilter.create = function (value0) {
        return function (value1) {
            return new ParameterValueFilter(value0, value1);
        };
    };
    return ParameterValueFilter;
})();
var AnyComboFilter = /* #__PURE__ */ (function () {
    function AnyComboFilter() {

    };
    AnyComboFilter.value = new AnyComboFilter();
    return AnyComboFilter;
})();
var sizeTypeMatching = function (v) {
    return function (v1) {
        if (v instanceof PizzaSize && v1 instanceof Restaumatic_PromotionsEngine_Cart_ProductItem.ProductPizza) {
            return true;
        };
        if (v instanceof DrinkSize && v1 instanceof Restaumatic_PromotionsEngine_Cart_ProductItem.ProductDrink) {
            return true;
        };
        return false;
    };
};
var relationToOp = function (dictOrd) {
    return function (v) {
        if (v instanceof LE) {
            return Data_Ord.lessThanOrEq(dictOrd);
        };
        if (v instanceof GE) {
            return Data_Ord.greaterThanOrEq(dictOrd);
        };
        if (v instanceof EQ) {
            return Data_Eq.eq(dictOrd.Eq0());
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 102, column 1 - line 102, column 65): " + [ v.constructor.name ]);
    };
};
var sizeMatching = function (v) {
    return function (v1) {
        return function (v2) {
            if (v1 instanceof Data_Maybe.Nothing) {
                return false;
            };
            if (v1 instanceof Data_Maybe.Just) {
                return relationToOp(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductSize)(v)(v1.value0)(v2);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 107, column 1 - line 107, column 72): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var inProductSingleFilter = function (product) {
    return function (v) {
        if (v instanceof ItemIdFilter) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Maybe.eqMaybe(Restaumatic_PromotionsEngine_Cart_Types.eqItemId))(Restaumatic_PromotionsEngine_Cart_ProductItem.itemId(product))(Data_Functor.map(Data_Functor.functorArray)(Data_Maybe.Just.create)(v.value0));
        };
        if (v instanceof ProductCategoryIdFilter) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Maybe.eqMaybe(Data_UUID.eqUUID))(Restaumatic_PromotionsEngine_Cart_ProductItem.productCategoryId(product))(Data_Functor.map(Data_Functor.functorArray)(Data_Maybe.Just.create)(v.value0));
        };
        if (v instanceof ParameterValueFilter) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Maybe.eqMaybe(Data_UUID.eqUUID))(Restaumatic_PromotionsEngine_Cart_ProductItem.customParameterValues(product)(v.value0))(Data_Functor.map(Data_Functor.functorArray)(Data_Maybe.Just.create)(v.value1));
        };
        if (v instanceof AnyComboFilter) {
            return Restaumatic_PromotionsEngine_Cart_ProductItem.isCombo(product);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 96, column 1 - line 96, column 83): " + [ product.constructor.name, v.constructor.name ]);
    };
};
var inProductFilter = function (productItem) {
    return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(inProductSingleFilter(productItem));
};
var genericSizeType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return PizzaSize.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return DrinkSize.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 20, column 1 - line 20, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PizzaSize) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof DrinkSize) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 20, column 1 - line 20, column 54): " + [ x.constructor.name ]);
    }
};
var showSizeType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSizeType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PizzaSize";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "DrinkSize";
        }
    })))
};
var udecodeSizeType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericSizeType)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "PizzaSize";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "DrinkSize";
        }
    })))(Unscramble_Enum.defaultEnumOptions)
};
var genericRelation = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return LE.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return GE.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return EQ.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 41, column 1 - line 41, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LE) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof GE) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof EQ) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 41, column 1 - line 41, column 54): " + [ x.constructor.name ]);
    }
};
var showRelation = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericRelation)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "LE";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "GE";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "EQ";
        }
    }))))
};
var udecodeRelation = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericRelation)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "LE";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "GE";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "EQ";
        }
    }))))(Unscramble_Enum.defaultEnumOptions)
};
var genericProductSingleFilter = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ItemIdFilter(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new ProductCategoryIdFilter(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ParameterValueFilter(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return AnyComboFilter.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 73, column 1 - line 73, column 76): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ItemIdFilter) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ProductCategoryIdFilter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ParameterValueFilter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
        };
        if (x instanceof AnyComboFilter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 73, column 1 - line 73, column 76): " + [ x.constructor.name ]);
    }
};
var showProductSingleFilter = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductSingleFilter)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Restaumatic_PromotionsEngine_Cart_Types.showItemId)))({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Data_UUID.showUUID)))({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_UUID.showUUID))(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Data_UUID.showUUID))))({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    })))))
};
var udecodeProductSingleFilter = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductSingleFilter)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_PromotionsEngine_Cart_Types.udecodeItemId))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Data_UUID.udecodeUUID))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgs1(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsProd(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Data_UUID.udecodeUUID))(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(/* #__PURE__ */ Unscramble.decodeArray1(Data_UUID.udecodeUUID)))))({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    }))))))(Unscramble_Generic.defaultOptions)
};
var eqSizeType = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSizeType)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))
};
var ordSizeType = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericSizeType)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))),
    Eq0: function () {
        return eqSizeType;
    }
};
var eqRelation = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericRelation)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var ordRelation = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericRelation)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments)))),
    Eq0: function () {
        return eqRelation;
    }
};
var eqProductSingleFilter = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericProductSingleFilter)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_PromotionsEngine_Cart_Types.eqItemId))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqArray(Data_UUID.eqUUID))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqProduct(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_UUID.eqUUID))(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqArray(Data_UUID.eqUUID)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))))
};
var ordProductSingleFilter = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericProductSingleFilter)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordArray(Restaumatic_PromotionsEngine_Cart_Types.ordItemId))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordArray(Data_UUID.ordUUID))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdProduct(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Data_UUID.ordUUID))(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordArray(Data_UUID.ordUUID)))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))))),
    Eq0: function () {
        return eqProductSingleFilter;
    }
};
var encodeSizeType = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericSizeType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "PizzaSize";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "DrinkSize";
        }
    })))
};
var encodeRelation = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericRelation)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "LE";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "GE";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "EQ";
        }
    }))))
};
var encodeProductSingleFilter = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductSingleFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_PromotionsEngine_Cart_Types.encodeItemId)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Data_UUID.encodeUUID)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UUID.encodeUUID)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Data_UUID.encodeUUID))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
};
var decodeSizeType = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericSizeType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "PizzaSize";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "DrinkSize";
        }
    })))
};
var decodeRelation = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericRelation)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "LE";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "GE";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "EQ";
        }
    }))))
};
var decodeProductSingleFilter = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductSingleFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ItemIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_PromotionsEngine_Cart_Types.decodeItemId))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductCategoryIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Data_UUID.decodeUUID))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ParameterValueFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UUID.decodeUUID)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Data_UUID.decodeUUID)))))(/* #__PURE__ */ Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AnyComboFilter";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))
};
export {
    PizzaSize,
    DrinkSize,
    LE,
    GE,
    EQ,
    ItemIdFilter,
    ProductCategoryIdFilter,
    ParameterValueFilter,
    AnyComboFilter,
    inProductFilter,
    inProductSingleFilter,
    relationToOp,
    sizeMatching,
    sizeTypeMatching,
    genericSizeType,
    showSizeType,
    eqSizeType,
    ordSizeType,
    encodeSizeType,
    decodeSizeType,
    udecodeSizeType,
    genericRelation,
    showRelation,
    eqRelation,
    ordRelation,
    encodeRelation,
    decodeRelation,
    udecodeRelation,
    genericProductSingleFilter,
    showProductSingleFilter,
    eqProductSingleFilter,
    ordProductSingleFilter,
    encodeProductSingleFilter,
    decodeProductSingleFilter,
    udecodeProductSingleFilter
};
//# sourceMappingURL=index.js.map
